@if (visible) {
  <div class="modal-backdrop" (click)="onBackdropClick($event)">
    <div class="modal-panel" role="dialog" aria-modal="true" [attr.aria-label]="'SETTINGS.TITLE' | translate" (click)="closeOpenDropdown()">


      <h2 class="modal-title">{{ 'SETTINGS.TITLE' | translate }}</h2>

      <div class="modal-fields">
        <div class="field-group">
          <label for="setting-country">{{ 'SETTINGS.COUNTRY' | translate }}</label>
            <div class="dropdown" [class.open]="openDropdown === 'country'" (click)="$event.stopPropagation()">
            <button type="button" class="dropdown-trigger" (click)="toggleDropdown('country')">
              <span>{{ selectedCountryName }}</span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="openDropdown === 'country'">
                <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#2F3133" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            @if (openDropdown === 'country') {
              <div class="dropdown-panel">
                @for (country of countries; track country.code) {
                  <button type="button" class="dropdown-option" [class.selected]="country.code === selectedCountryCode" (click)="selectCountry(country.code)">{{ country.name }}</button>
                }
              </div>
            }
          </div>
        </div>

        <div class="field-group">
          <label for="setting-language">{{ 'SETTINGS.LANGUAGE' | translate }}</label>
            <div class="dropdown" [class.open]="openDropdown === 'language'" (click)="$event.stopPropagation()">
            <button type="button" class="dropdown-trigger" (click)="toggleDropdown('language')">
              <span>{{ selectedLanguageName }}</span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="openDropdown === 'language'">
                <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#2F3133" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            @if (openDropdown === 'language') {
              <div class="dropdown-panel">
                @for (lang of availableLanguages; track lang.code) {
                  <button type="button" class="dropdown-option" [class.selected]="lang.code === selectedLanguageCode" (click)="selectLanguage(lang.code)">{{ lang.name }}</button>
                }
              </div>
            }
          </div>
        </div>

        <div class="field-group">
          <label for="setting-currency">{{ 'SETTINGS.CURRENCY' | translate }}</label>
            <div class="dropdown" [class.open]="openDropdown === 'currency'" (click)="$event.stopPropagation()">
            <button type="button" class="dropdown-trigger" (click)="toggleDropdown('currency')">
              <span>{{ selectedCurrencyName }}</span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="openDropdown === 'currency'">
                <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#2F3133" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            @if (openDropdown === 'currency') {
              <div class="dropdown-panel">
                @for (currency of currencies; track currency.code) {
                  <button type="button" class="dropdown-option" [class.selected]="currency.code === selectedCurrencyCode" (click)="selectCurrency(currency.code)">{{ currency.name }}</button>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <div class="modal-actions">
        <button class="btn-save" type="button" (click)="save()">{{ 'SETTINGS.SAVE' | translate }}</button>
        <button class="btn-cancel" type="button" (click)="cancel()">{{ 'SETTINGS.CANCEL' | translate }}</button>
      </div>

    </div>
  </div>
}
